module.exports = __webpack_public_path__ + "static/img/mscyH5.4adc40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mscyH5.png
// module id = VZvu
// module chunks = 0